export default __webpack_public_path__ + "assets/models/27f8c0372d683878e0c6e436faaea508.gltf";